// fields for step one
export const entityTypeKey = 'beneficiary.entity_type';
export const bankCountryCodeKey = 'beneficiary.bank_details.bank_country_code';
export const accountCurrencyKey = 'beneficiary.bank_details.account_currency';

// fields for step two
export const paymentMethodKey = 'payment_methods';
export const localClearingSystemKey = 'beneficiary.bank_details.local_clearing_system';

// fields for step three/four
export const fieldAppearanceBankDetails = [
    { path: 'beneficiary.company_name' },
    { path: 'beneficiary.first_name' },
    { path: 'beneficiary.last_name' },
    { path: 'beneficiary.bank_details.bank_name' },
    { path: 'beneficiary.bank_details.account_number' },
    { path: 'beneficiary.bank_details.iban' },
    { path: 'beneficiary.bank_details.swift_code' },
    { path: 'beneficiary.bank_details.account_name' },
    { path: 'beneficiary.bank_details.account_routing_type1' },
    { path: 'beneficiary.bank_details.account_routing_value1' },
    { path: 'beneficiary.bank_details.account_routing_type2' },
    { path: 'beneficiary.bank_details.account_routing_value2' },
    { path: 'beneficiary.bank_details.account_currency' },
    { path: 'beneficiary.bank_details.bank_country_code' },
];

export const fieldAppearanceAddress = [
    { path: 'beneficiary.address.city' },
    { path: 'beneficiary.address.country_code' },
    { path: 'beneficiary.address.street_address' },
    { path: 'beneficiary.address.state' },
    { path: 'beneficiary.address.postcode' },
];

export const keysGeneral = [entityTypeKey, bankCountryCodeKey, accountCurrencyKey];
export const keysPaymentMethod = [paymentMethodKey, localClearingSystemKey];
export const keysBankDetails = fieldAppearanceBankDetails.map((field) => field.path);
export const keysAddress = fieldAppearanceAddress.map((field) => field.path);
